import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import { talentFileUploader } from "../../data-services/assignmets";

import {
  adjustBackgroundHeight,
  adjustBorderHeight,
  getQrCodeInfo,
} from "../../common/common";
import ProfileFileuploaderQR19 from "../../push-components/ProfileFileuploader/ProfileFileuploaderQR19";



const StepQR19UploadPhoto: React.FC = () => {
  const history = useHistory();

  const [fileName, setFileName] = useState('');
  const [talentHeadshot, setTalentHeadshot] = useState<string>("");

  const handleFileChange = (event:any) => {
    const file = event?.target?.files[0];
    if (file) {
      setFileName(file.name);
    }
  }

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  const onRemoveCallback = useCallback(() => {
    setTalentHeadshot("");
    setFileName("");
  }, []);

    const submitPhotoHandler = async (event: any) => {
  
      event.preventDefault();
      let model_photo = new FormData(event.target);
      model_photo.append("type", "profile_photos");
  
      let file_upload: any = await talentFileUploader(model_photo, "");
  
      history.push('/QR19Success');
    };

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(810);
    adjustBackgroundHeight(810);
  }, []);

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      talent_mobile: "",
      talent_terms: false,
      talent_mobile_otp: "",
      promotion_text_msg: false,
      talent_fname: "",
      talent_lname: "",
      talent_display_name: "",
      talent_gender: "",
      talent_birth_date: "",
      talent_address: "",
      talent_apartment_no: "",
      talent_city: "",
      talent_country: "",
      talent_state: "",
      talent_email: "",
      marketing_emails: false,
      talent_passowrd: "",
      talent_zipcode: "",
    },
    mode: "onBlur",
  });


  return (
    <IonPage style={{background: '#ee1d25', alignItems: 'center'}}>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`} style={{maxWidth: '420px', maxHeight: '900px', margin: '0 auto'}}>
        <div className="lay__background" style={{maxHeight: '810px', background: '#ee1d25'}}>
          <img src="https://pulseqr.b-cdn.net/qr19LYT/Background--no-logo--red.png" />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`} style={{paddingLeft: '20px', paddingRight: '20px'}}>

            <div className="lay__logo" style={{paddingTop: '30px'}}>
              <div className="">
                <img style={{paddingTop: '0', marginTop: '0'}} src="https://pulseqr.b-cdn.net/qr19LYT/logo - white.png" />
              </div>
            </div>

            <div className="img__first" style={{
              marginTop: '75px',
              marginBottom: '15px',
              maxWidth: '300px',
            }}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="https://pulseqr.b-cdn.net/qr19LYT/p4-img1.png" />
              </div>
            </div>

            <form id="psup__form" onSubmit={submitPhotoHandler}>
              <div className="">
                <ProfileFileuploaderQR19
                  name="head_shot"
                  limit="1"
                  id="model_headshot"
                  cropp_ratio="headshot"
                  files={[]}
                  click={onRemoveCallback}
                  handleFileChange={handleFileChange}
                />
              </div>

              <div className="img__inline" style={{marginTop: '0px', position: 'relative', zIndex: 3, width: '230px', opacity: fileName ? 1 : 0.5}}>
                <IonButton
                  expand="block"
                  mode="ios"
                  type="submit"
                  disabled={!fileName}
                  style={{marginTop: '0px', height: '50px'}}
                  className="form__submit-img upload-photo__submit-btn"
                >
                  <img src="https://pulseqr.b-cdn.net/qr19LYT/CTA-Submit4.png" />
                </IonButton>
              </div>
            </form>
          </div>}
      </IonContent>

    </IonPage>
  );
};

export default StepQR19UploadPhoto;
